import React from 'react';
import i18n from 'i18next';
import { SpotIcon, Spot } from '../../../../../../../Spot';

import './EulaConfirmationPageFooter.scss';

interface IProps {
  submitFunction: () => void;
  buttonText?: string;
}

function EulaConfirmationPageFooter({ submitFunction, buttonText }: IProps) {
  const handleSubmit = () => {
    submitFunction();
  };

  return (
    <div className={'enrollment-eula-confirmation-footer-container'}>
      <div className={'confirmation-content-container'}>
        <div className={'confirmation-title'} data-automation-id={'enrollmentConfirmationTextTitle'}>
          {i18n.t('eulaConfirmationTextTitle')}
        </div>
        <div className={'confirmation-text'} data-automation-id={'enrollmentConfirmationText'}>
          {i18n.t('eulaConfirmationText')}
        </div>
        <div className={'enrollment-eula-confirmation-footer-button-container'}>
          <SpotIcon
            fill={'white'}
            title={'confirmationButton'}
            iconName={Spot.icons.back}
            data-automation-id={'confirmationCompleteButton'}
            className={'confirmation-arrow-button'}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
}

export default EulaConfirmationPageFooter;
